export class Time
{
    static originTime:number = 0;
    static time:number = 0;
    static deltaTime:number = 0;
    static lastTime:number = 0;
    static fps:number = 0;

    private static frameCount = 0;
    private static frameCountTimer = 0;
    private static lastFrame = 0;

    private static fpsLimit = 0;

    public static update(t:DOMHighResTimeStamp)
    {
        this.time = 0.001 * t;

        if (this.originTime == 0)  // first run
        {
            this.lastTime = this.originTime = this.lastFrame = this.time;
        } 
        else
        {
            this.deltaTime = this.time - this.lastTime;
            this.lastTime = this.time; 
            this.frameCountTimer += this.deltaTime;
        
            let doRender = false;
        
            if (this.fpsLimit == 0)
                doRender = true;
            else
            {
                let sinceLast = this.time - this.lastFrame;
                if (sinceLast >= 1.0 / this.fpsLimit)
                {
                    doRender = true;
                    this.lastFrame = this.time;    
                }
            }
        
            if (doRender)
            {
                this.frameCount++;
                if (this.frameCountTimer > 1)
                {
                    this.fps = this.frameCount / this.frameCountTimer;
                    this.frameCount = 0;
                    this.frameCountTimer -= 1;    
                }
            }
        
            return doRender;    
        }
        return true;
    }
}